// extracted by mini-css-extract-plugin
export default {"root":"EnglishScope_root__NLLRA"};